import { gql } from '@apollo/client';

// Build a fresh inline gql query with hardcoded values (no $variable type declarations)
// This matches the Postman working payload exactly — backend doesn't support Long scalar in variables
export const buildLocationReportQuery = ({
  year,
  month,
  stateId,
  cityId,
  page,
  size,
}) => {
  const safeStateId = stateId === null ? 'null' : stateId;
  const safeCityId = cityId === null ? 'null' : cityId;
  return gql`
    query AdminLocationReport {
      adminLocationReport(
        year: ${year}
        month: ${month}
        stateId: ${safeStateId}
        cityId: ${safeCityId}
        page: ${page}
        size: ${size}
      ) {
        totalOffers
        totalOfferQty
        totalDemands
        totalDemandQty
        totalSellers
        totalBuyers
        offers {
          offerId
          seller
          createdBy
          createdByPhone
          createdByCallingCode
          grade
          location
          totalQty
          minimumQty
          rate
          status
          createdDate
          expiryDate
        }
        demands {
          demandId
          buyer
          createdBy
          createdByPhone
          createdByCallingCode
          grade
          location
          totalQty
          minimumQty
          rate
          status
          createdDate
          expiryDate
        }
      }
    }
  `;
};

// Build a fresh inline gql query with hardcoded values for user report
export const buildUserReportQuery = ({ year, month, traderId, page, size }) => {
  return gql`
    query AdminUserReport {
      adminUserReport(
        year: ${year}
        month: ${month}
        traderId: ${traderId}
        page: ${page}
        size: ${size}
      ) {
        totalOffers
        totalOfferQty
        offerQtyUnit
        totalDemands
        totalDemandQty
        demandQtyUnit
        offers {
          offerId
          seller
          createdBy
          createdByPhone
          createdByCallingCode
          grade
          location
          totalQty
          minimumQty
          rate
          status
          createdDate
          expiryDate
        }
        demands {
          demandId
          buyer
          createdBy
          createdByPhone
          createdByCallingCode
          grade
          location
          totalQty
          minimumQty
          rate
          status
          createdDate
          expiryDate
        }
      }
    }
  `;
};
